import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Dashboard, Presale, Transaction, Settings, Logout, Voucher } from "../../components/Icons";
import back from "../../assets/images/back.jpg";
import Logo from "../../assets/logo.png";
import "./index.scss";

const Layout = (props: any) => {
  const [currentPage, setCurrentPage] = useState<any>();
  const history = useHistory();
  const onPage = (key: string, url: string) => {
    setCurrentPage(key);
    history.push(url);
  };
  const page = currentPage || "dashboard";

  const menus: Array<{
    key: string;
    url: string;
    icon: any;
    label: string;
  }> = [
    {
      key: "dashboard",
      url: "/dashboard",
      icon: <Dashboard size={25} />,
      label: "Dashboard",
    },
    {
      key: "swap",
      url: "/swap",
      icon: <Presale size={25} />,
      label: "Swap",
    },
    {
      key: "pool",
      url: "/pool",
      icon: <Voucher size={25} />,
      label: "Pools",
    },

    // {
    //   key: "logout",
    //   url: "",
    //   icon: <Logout size={25} />,
    //   label: "Logout",
    // },
  ];

  return (
    <div
      style={{
        backgroundImage: `url(${back})`,
        backgroundSize: "auto",
        minHeight: "100vh",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
        backgroundColor: "#0a0a0a",
      }}
    >
      <header style={{ backgroundColor: "#0a0a0a", height: "80px" }} className="header-panel">
        <div className="justify">
          <Link className="title flex middle" to="/" style={{ margin: "0 auto" }}>
            <img src={Logo} style={{ width: 100, height: "auto", marginTop: "20px" }} alt="logo" />
          </Link>
        </div>
      </header>
      <div className="block">
        <div className="topmenu-panel">
          {menus.map((v) => (
            <a
              key={v.key}
              onClick={() => onPage(v.key, v.url)}
              className={"topmenu" + (page === v.key ? " active" : "")}
            >
              <p>{v.icon}</p>
              <p>{v.label}</p>
            </a>
          ))}
        </div>
        <div className="flex" style={{ height: "100%" }}>
          <div className="sidebar-panel">
            <div className="sidebar">
              <img src={Logo} style={{ width: 200, height: "auto", margin: "40px 30px" }} alt="logo" />
              {/* <p style = {{color : "#3d3d3d", textAlign : "center"}}>#82382948343</p> */}
              {/* <p style = {{color : "#3d3d3d", textAlign : "center"}}>{user ? }</p> */}
              {menus.map((v) => (
                <a key={v.key} onClick={() => onPage(v.key, v.url)} className={page === v.key ? " active" : ""}>
                  <i>{v.icon}</i>
                  <span>{v.label}</span>
                </a>
              ))}
            </div>
          </div>
          <div className="main-container">
            <main style={{ display: "block", minHeight: "100%" }}>{props.children}</main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
